const actions = {
  async listInvoice(context, payload) {
    try {
      const response = await this.$api.call(
        "finops_commission_from_insurance_transaction.list",
        payload,
      );
      if (response.data === null) {
        response.data = [];
      }
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationInvoiceList", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationInvoiceList", responseData);
      }

      context.commit("mutationInvoiceListMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationInvoiceList", []);
      context.commit("mutationInvoiceListMeta", {});

      throw error;
    }
  },
  setSelectedInsurer(context, payload) {
    context.commit("mutationSelectedInsurer", payload);
  },
};

export default actions;
